"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { GalleryItem } from "@shared/ui/gallery-item";

import type { TrailPageType } from "../../model";

import s from "./gallery.module.scss";

export type GalleryProps = ComponentProps<"div"> & {
  className?: string;
  gallery?: TrailPageType["gallery"];
};

export const Gallery = (props: GalleryProps) => {
  const { className, gallery } = props;

  return (
    <div className={clsx(s.root, className)}>
      {gallery?.map((item, idx) =>
        item ? (
          <GalleryItem key={item?.id ?? idx} item={item} className={s.item} />
        ) : null,
      )}
    </div>
  );
};

Gallery.displayName = "Gallery";
